(function (app, ng) {
    app.config(["figModalStateProvider", function (figModalStateProvider) {
        figModalStateProvider.state("Home.ReviewQueue.Notes",
            {
                url: "/Notes/{queueEntryId}",
                component: "reviewQueueNotes",
                requiredPermissions: [{ AccessObject: "ReviewQueueNotes", ActionType: "View" }],
                resolve: {
                    notes: ["queueEntryApi", "$stateParams", function (queueEntryApi, $stateParams) {
                        return queueEntryApi.getNotesForEntry($stateParams.queueEntryId);
                    }],
                    queueEntryId: ["$stateParams", function ($stateParams) { return $stateParams.queueEntryId; }],
                    transaction: ["queueEntryApi", "$stateParams", function (queueEntryApi, $stateParams) {
                        return queueEntryApi.getTransactionForQueueEntry($stateParams.queueEntryId);
                    }]
                }
            }, { clickOutsideToClose: false });
    }]);

    app.component("reviewQueueNotes",
        {
            templateUrl: "/App/ReviewQueue/Notes/template.html",
            controller: reviewQueueNotesController,
            bindings: {
                notes: "<",
                queueEntryId: "<",
                transaction: "<"
            }
        });

    reviewQueueNotesController.$inject = ["$mdDialog", "_", "queueEntryApi", "figToaster", "figToastContainers", "permissionService"];

    function reviewQueueNotesController($mdDialog, _, queueEntryApi, figToaster, figToastContainers, permissionService) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                permissionService: permissionService,
                UI: {
                    isClosing: false,
                    isAdding: false,
                    isDeleting: false
                },
                close: close,
                addNote: addNote,
                removeNote: removeNote
            });

        this.$onInit = function () {
            $ctrl.noteId = _.max(_.map($ctrl.notes, "Id")) || 0;
        };

        function close() {
            $ctrl.UI.isClosing = true;

            return $mdDialog.hide();
        }

        function addNote(text) {
            $ctrl.UI.isAdding = true;

            var model = {
                Text: text,
                Id: $ctrl.noteId++
            };

            return queueEntryApi.addQueueEntryNote($ctrl.queueEntryId, model).then(function (response) {
                $ctrl.notes.push(response);
                $ctrl.UI.isAdding = false;
            });
        }

        function removeNote(note) {
            return figToaster.showYesNo("Are you sure you would like to remove this note?",
                "bottom center", figToastContainers.get("review-queue-note"), true).then(function (response) {
                    if (!response) return;

                    $ctrl.UI.isDeleting = true;

                    queueEntryApi.removeQueueEntryNote($ctrl.queueEntryId, note.Id).then(function () {
                        $ctrl.UI.isDeleting = false;
                        $ctrl.notes.splice($ctrl.notes.indexOf(note), 1);
                    });
                });
        }
    }
})(window.app, window.angular); // jshint ignore:line